import EventBusConst from '@/events/event.bus.const';
import siteConfigService from '@/services/site.config.service';
import { EventBus, EventBusEmit } from '@/events/event.bus';
import EventHandledStatus from '@/events/entities/event.handled.status';
import EventHandledCode from '@/events/entities/event.handled.code';
import cacheService from '@/services/cache.service';
import store from '@/store';
import Logger from '@/utils/logger.utils';
import { appEnvironment } from '@/app-environment';

class LogoutEventHandler implements baseEventHandler {
  register() {
    EventBus.$on(EventBusConst.LOGOUT_EVENT, this.handleLogoutdEvent);
    Logger.debug('registered LogoutEventHandler!!');
  }

  unRegister() {
    EventBus.$off(EventBusConst.LOGOUT_EVENT, this.handleLogoutdEvent);
    Logger.debug('un registered LogoutEventHandler!!');
  }

  private defaultLogoutUrl: string = '/stdpl/logout.html';

  @EventBusEmit(EventBusConst.LOGOUT_EVENT_HANDLED)
  public async handleLogoutdEvent(msg: string): Promise<EventHandledStatus<string>> {
    return new LogoutEventHandler().pureLogoutHandler(msg); // using this is not good enough. this contains value of the callers Vue instance
  }

  async pureLogoutHandler(msg: string) {
    await cacheService.clearAll();
    let apiEndpoint: string = await siteConfigService.getApiEndpoint('logoutUrl');
    if (!apiEndpoint || apiEndpoint === '') {
      apiEndpoint = this.defaultLogoutUrl;
    }
    const eventHandledStatus: EventHandledStatus<string> =
      {
        code: EventHandledCode.OK,
        msg,
        original: msg,
        extra: { logoutUrl: apiEndpoint },
      };
    await store.dispatch('mainModule/clearAll');
    return eventHandledStatus;
  }

  /**
   * Performs logout according to {@link appEnvironment.logoutOnTokenExpired} value.
   * @param error value to be thrown in case that logout is not enabled.
   */
  async logout(error?: Error): Promise<void> {
    if (!appEnvironment.logoutOnTokenExpired && !store.getters['mainModule/pageContext'].requireLogin) {
      if (error !== undefined) throw error;
      return;
    }
    const r = await this.pureLogoutHandler('logout');
    window.location.href = r.extra.logoutUrl;
  }
}

export default new LogoutEventHandler();
